import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 36, className = "", ...props }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
    {...props}
  >
    {children}
  </motion.div>
);

export const ChapterHead = ({ number, label, title, center = false, dark = false, testid }) => (
  <Reveal className={center ? "text-center" : ""}>
    <p
      className={`text-xs tracking-[0.28em] uppercase mb-5 ${
        dark ? "text-[#C6A15B]" : "text-[#8C7A56]/70"
      }`}
      data-testid={testid ? `${testid}-eyebrow` : undefined}
    >
      Chapter {number} — {label}
    </p>
    <h2
      className={`font-serif-display text-2xl sm:text-3xl lg:text-4xl font-normal tracking-tight leading-[1.12] ${
        dark ? "text-[#FDFBF7]" : "text-[#1B1915]"
      }`}
      data-testid={testid ? `${testid}-title` : undefined}
    >
      {title}
    </h2>
    <div className={`mt-7 flex items-center gap-3 ${center ? "justify-center" : ""}`}>
      <span className={`h-px w-12 ${dark ? "bg-[#C6A15B]/60" : "bg-[#C6A15B]"}`} />
      <span className={`w-1.5 h-1.5 rotate-45 ${dark ? "bg-[#C6A15B]/60" : "bg-[#C6A15B]"}`} />
      <span className={`h-px w-12 ${dark ? "bg-[#C6A15B]/60" : "bg-[#C6A15B]"}`} />
    </div>
  </Reveal>
);

export const CHAKRAS = [
  { key: "crown", name: "Crown Chakra", colour: "White", hex: "#D9D5C7", light: true, traits: ["Spirituality", "Awareness", "Clarity"], desc: "A quiet reminder of clarity and perspective." },
  { key: "third-eye", name: "Third Eye Chakra", colour: "Purple", hex: "#8B5CF6", traits: ["Intuition", "Reflection", "Insight"], desc: "For moments of intuition and reflection." },
  { key: "throat", name: "Throat Chakra", colour: "Blue", hex: "#0284C7", traits: ["Communication", "Expression", "Truth"], desc: "A nod to honest expression and open conversation." },
  { key: "heart", name: "Heart Chakra", colour: "Green", hex: "#10B981", traits: ["Compassion", "Balance", "Connection"], desc: "A symbol of warmth, balance and connection." },
  { key: "solar-plexus", name: "Solar Plexus Chakra", colour: "Yellow", hex: "#EAB308", traits: ["Confidence", "Purpose", "Personal strength"], desc: "A spark of confidence for your everyday." },
  { key: "sacral", name: "Sacral Chakra", colour: "Orange", hex: "#F97316", traits: ["Creativity", "Joy", "Expression"], desc: "A creative energy for joyful spaces." },
  { key: "root", name: "Root Chakra", colour: "Red", hex: "#EF4444", traits: ["Grounding", "Stability", "Security"], desc: "A grounding presence at the base of it all." },
];

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "The Chakra Tree", href: "#chakra-tree" },
  { label: "The Seven Chakras", href: "#chakras" },
  { label: "Craftsmanship", href: "#craftsmanship" },
  { label: "Product Details", href: "#details" },
  { label: "Our Story", href: "#story" },
  { label: "Enquire", href: "#enquire" },
];
